<template>
  <dx-select-box
    ref="selectBox"
    :value="value"
    :search-enabled="true"
    :data-source="options"
    :display-expr="label"
    :value-expr="code"
    :height="height"
    @value-changed="change"
  />
</template>

<script>
import {DxSelectBox} from "devextreme-vue";

const styles = {
  'sm': {
    height: 19,
    fontSize: "0.8em"
  },
  'm': {
    height: 30,
    fontSize: "0.9em"
  }
}
export default {
  components: {
    DxSelectBox
  },
  props: {
    options: {
      default: () => [],
      type: Array
    },
    value: {
      default: undefined,
    },
    label: {
      default: null,
    },
    code: {
      default: '',
      type: String
    },
    title: {
      default: '',
      type: String
    },
    disabled: {
      default: false,
      type: Boolean
    },
    multiple: {
      default: false,
      type: Boolean
    },
    reduce: {
      default: null,
      type: Function
    },
    invalid: {
      default: false,
      type: Boolean
    },
    required: {
      default: false,
      type: Boolean
    },
    tabIndex: {
      type: Number,
      default: null
    },
    labelRenderer: {
      type: Function,
    },
    size: {
      type: String,
      default: 'm'
    }
  },
  data() {
    return {
      isInitalized: false,
      searchTimeoutIndex: 0,
      filteredOptions: [],
      selectSearchText: '',
      selectedOption: undefined,
      showOptions: false,
      internValue: this.value,
      contextMenuPosition: {
        x: 0,
        y: 0
      }
    }
  },
  computed: {
    height() {
      if (styles[this.size]) {
        return styles[this.size].height;
      }

    },
    fontSize() {
      if (styles[this.size])
        return styles[this.size].fontSize;
    }
  },
  methods: {
    resolveLabel(option) {
      if (this.labelRenderer) {
        if (typeof option === 'object')
          return this.labelRenderer(option)

        return option;
      }

      if (option &&
        typeof option === 'object' && this.label.indexOf('.') >= 0) {
        const parts = this.label.split('.');
        let value = option;
        for (let part of parts) {
          value = value[part];
        }
        return value;
      }
      return option[this.label];
    },
    change(e) {
      this.$emit('input', e.value);
      this.$emit('change', e.value);
    }
  },
  mounted() {
    if (this.$refs.selectBox.$el) {
      const input = this.$refs.selectBox.$el.querySelector(".dx-texteditor-input");
      input.style.fontSize = this.fontSize;
    }
  }
}
</script>


